import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {NotificationsService} from 'angular2-notifications';
import {ActivatedRoute} from '@angular/router';
import {PieChartComponent} from '../zoomView/pie-chart/pie-chart.component';
import {ModalService} from '../../../services/modalService/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { BackendTranslateService } from '../../../helper/backend-translate.service';
@Component({
  selector: 'app-denial-reasons',
  templateUrl: './denial-reasons.component.html',
  styleUrls: ['./denial-reasons.component.css', '../myreports.component.css']
})
export class DenialReasonsComponent implements OnInit {

  ruid: string;
  public chartData: any = {};
  public pie_ChartData = [];
  public options = {
    height: 400,
    titlePosition: 'out',
      chartArea: {height: '100%', width: '60%', left: 150},
    showAnnotations: false
  };
  isloggedIn = false;
  isLicense: string;

  chartError = false;

  constructor(private apiService: ApiService,
              private route: ActivatedRoute,
              private notifications: NotificationsService,
              private modalService: ModalService,
              private translate: TranslateService,
              private backendTranslate: BackendTranslateService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        this.isloggedIn = true;
        this.apiService.getSummary(this.ruid)
          .subscribe((res) => {
            this.isLicense = res.isLicense;
            if (!res.isLicense) {
              this.apiService.getChartData(this.ruid, 'DENIALS_BY_REASON')
                .subscribe((chartDataRes) => {
                  chartDataRes.data[0] = this.backendTranslate.translateCollection(chartDataRes.data[0]);
                  if (chartDataRes.data[1]) {
                    this.chartData = chartDataRes;
                    this.pie_ChartData = chartDataRes.data;
                  }
                }, (chartDataError) => {
                    this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(chartDataError, this.translate.instant('report.denialReason.fail')));
                });
            }
          }, (error) => {
              this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error,  this.translate.instant('report.denialReason.invalidRuid')));
          });
      }
    });
  }

  zoomView() {
    if (this.pie_ChartData.length === 0) {
        return;
    }
    this.modalService.open(PieChartComponent, {
      title: this.translate.instant('reports.denialReason.title'),
      data: {
        chartData: this.chartData,
        isLicense: this.isLicense,
        options: this.options
      }
    }).subscribe(model => {
    });
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/denial-reasons/denial-reasons.component.ts